{
  "global.siteDescription": "Stell dich in 30 Sekunden persönlich vor, damit andere dich schnell kennenlernen.",
  "global.languageSwitch": "Sprache wechseln",
  "global.languageCurrent": "Aktuelle Sprache: {locale}",
  "global.language.zh-CN": "中文",
  "global.language.zh-TW": "繁體中文",
  "global.language.en": "English",
  "global.language.ja": "日本語",
  "global.language.ko": "한국어",
  "global.language.es": "Español",
  "global.language.fr": "Français",
  "global.language.de": "Deutsch",
  "global.language.pt-BR": "Português (Brasil)",
  "global.language.ru": "Русский",
  "global.language.ar": "العربية",
  "common.close": "Schließen",
  "common.cancel": "Abbrechen",
  "common.save": "Speichern",
  "common.delete": "Löschen",
  "common.edit": "Bearbeiten",
  "common.manage": "Verwalten",
  "common.login": "Anmelden",
  "common.logout": "Abmelden",
  "common.loggingOut": "Abmeldung läuft",
  "common.logoutRetry": "Abmeldung erneut versuchen",
  "common.preview": "Vorschau",
  "common.email": "Email",
  "common.inviteCode": "Einladungscode",
  "common.loading": "Wird geladen",
  "editor.publish.processing": "Wird noch verarbeitet",
  "common.localDraft": "Lokaler Entwurf",
  "common.publicBeta": "Öffentliche Beta",
  "common.serviceStatus": "Servicestatus",
  "common.optional": "Optional",
  "common.page": "Seite",
  "common.reason": "Grund",
  "common.description": "Details",
  "common.submit": "Absenden",
  "nav.login": "Anmelden",
  "nav.draftFirst": "Entwurf starten",
  "home.action.create": "Meine Vorstellung erstellen",
  "home.action.continue": "Weiterschreiben",
  "home.action.manage": "Vorstellung verwalten",
  "home.action.agent": "Agent schreibt für dich",
  "home.meta.title": "30s.to — 30 Sekunden, um dich kennenzulernen.",
  "home.meta.description": "Wer allein vorangeht, braucht Menschen, die ihn verstehen. 30 Sekunden, um dich kennenzulernen. Wer du bist, was du gerade machst, was du bisher gemacht hast und welche Ressourcen du anbieten kannst. Hilf anderen, zu entdecken, was sie interessiert, und mit dir in Kontakt zu kommen.",
  "home.title": "30 Sekunden,\num dich kennenzulernen.",
  "home.freeNote": "Erstellen, veröffentlichen und teilen. Für immer kostenlos.",
  "home.kicker": "Wer allein vorangeht, braucht Menschen, die ihn verstehen.",
  "home.value.copy": "Wer du bist, was du gerade machst, was du bisher gemacht hast und welche Ressourcen du anbieten kannst. Hilf anderen, zu entdecken, was sie interessiert, und mit dir in Kontakt zu kommen.",
  "home.features.label": "Funktionen",
  "home.features.time.tab": "In 30 Sekunden gelesen",
  "home.why.copy": "Schreib nur das Wichtigste. Je länger die Vorstellung, desto weniger lesen sie zu Ende. 30 Sekunden sind genau richtig.",
  "home.principle.expression.title": "Drück dich aus",
  "home.principle.expression.copy": "Ordne deine Erfahrungen, Arbeiten, Ideen und Ressourcen auf deine Weise. Zeig, was andere über dich wissen sollen.",
  "home.principle.link.title": "Dein eigener 30s.to-Link",
  "home.principle.link.copy": "30s.to/@you ist kurz, einprägsam und bringt es auf den Punkt: dich in 30 Sekunden kennenlernen.",
  "home.principle.theme.title": "Vielfältige Themes für deinen Ausdruck",
  "home.principle.theme.copy": "Klar, retro oder kräftig und farbenfroh. Wähle ein Theme, das zu dir passt und deinen Stil auf den ersten Blick zeigt.",
  "home.footer.tagline": "Sag weniger, damit das Wesentliche auffällt.",
  "home.footer.navigation": "Fußzeilennavigation",
  "home.demo.linkNotice": "Dies ist ein Demo-Link. Erstellen Sie Ihr 30-sekündiges Intro und fügen Sie Ihr eigenes hinzu.",
  "home.demo.profile.name": "Maya Chen",
  "home.demo.profile.identity": "Unabhängiger Produktdesigner, der komplexe Probleme in einfache Produkte verwandelt",
  "home.demo.profile.tag.product": "Produktdesign",
  "home.demo.profile.tag.indie": "Indie-Produkte",
  "home.demo.profile.tag.ai": "AI Werkzeuge",
  "home.demo.profile.body": "## Gerade\nIch entwickle Briefly, damit unabhängige Designer weniger Notizen verschieben und mehr Menschen verstehen. Vor dem Entwerfen gehe ich die echte Aufgabe mit einem Nutzer durch.\n\n## Mein Werdegang\n2020–2023: Produktdesign für Editor und Einführung in einem Kollaborationssoftware-Team. Mit Entwicklern zerlegte ich komplexe Abläufe in machbare Schritte.\n\nSeit 2024 selbstständig: Nutzerforschung und Interaktionsdesign für junge Teams, daneben eigene kleine Produkte.\n\n## Projekte\n- [Relay](https://example.com/projects/relay): Mein Design für ein Entscheidungsprotokoll verbindet Ergebnisse, Gründe und Verantwortliche, damit neue Teammitglieder den Hintergrund verstehen.\n- [Briefly](https://example.com/projects/briefly): im kleinen Pilotbetrieb. Ordnet Interviewnotizen nachvollziehbaren Themen zu und bewahrt Originalzitate zur Überprüfung.\n\n## Was ich teilen kann\nFeedback liegt vor, aber der nächste Schritt ist unklar? Ich helfe bei der Problemklärung und mit testbaren Prototypen. Teams am Anfang ihrer Nutzerforschung gebe ich auch Interviewleitfäden und Notizvorlagen weiter.\n\n## Austausch\nIch möchte mit Menschen, die kleine Produkte sorgfältig gestalten, über erste Interviews, Abwägungen und selbstständige Arbeit sprechen. Am Wochenende erkunde ich Nachbarschaftsläden: Eine handgeschriebene Preisliste kann mehr erklären als ein Produkthandbuch.",
  "home.demo.profile.link.website": "Arbeiten",
  "home.demo.profile.link.github": "GitHub",
  "home.demo.profile.link.calendar": "Buchen Sie einen Chat",
  "handleStart.kicker": "Öffentliche URL",
  "handleStart.title": "Wähle deine 30s.to-URL",
  "handleStart.copy": "Wähle zuerst eine leicht merkbare URL und schreibe dann deine 30-Sekunden-Vorstellung. Ein vorhandener Entwurf bleibt erhalten.",
  "handleStart.label": "Deine URL",
  "handleStart.help.empty": "4-24 Kleinbuchstaben. Dadurch wird nur ein Entwurf gespeichert; Die Verfügbarkeit wird bei der Veröffentlichung bestätigt.",
  "handleStart.help.ok": "Format sieht gut aus. Die Verfügbarkeit wird bei der Veröffentlichung erneut überprüft.",
  "handleStart.submit": "Schreiben Sie weiter",
  "handleAvailability.checking": "Diese URL wird überprüft…",
  "handleAvailability.available": "Jetzt verfügbar. Nach erfolgreicher Veröffentlichung wird es Ihr Eigentum.",
  "handleAvailability.owned": "Sie besitzen diese Adresse bereits.",
  "handleAvailability.assigned": "Diese Adresse ist Ihnen zugeordnet und wird nach der Veröffentlichung wirksam.",
  "handleAvailability.failed": "Diese URL konnte nicht geprüft werden. Versuche es erneut.",
  "handleAvailability.rateLimited": "Zu viele Prüfungen. Versuche es in {minutes} Minuten erneut.",
  "handleAvailability.retry": "Erneut prüfen",
  "handleAvailability.suggestions": "Oder probiere",
  "handleAvailability.cooldown": "Die öffentliche URL ist noch in der 30-tägigen Wartezeit. Ab {date} kannst du sie wieder ändern oder die aktuell veröffentlichte URL wiederherstellen.",
  "editor.shell.loading": "Der Erstellungsfluss wird geladen",
  "editor.shell.workspace": "30-sekündiger Einführungsarbeitsbereich",
  "editor.shell.canvas": "30-Sekunden-Intro-Schreibfläche",
  "editor.command.aria": "Editor-Befehlsleiste",
  "editor.command.publish": "Veröffentlichen",
  "editor.command.publishUpdate": "Änderungen veröffentlichen",
  "editor.command.publishSettings": "Veröffentlichungseinstellungen",
  "editor.command.dashboard": "Dashboard",
  "editor.publish.success": "Veröffentlicht",
  "editor.publish.successAfterLogin": "Eingeloggt und veröffentlicht",
  "editor.publish.publishing": "Wird veröffentlicht…",
  "editor.publish.publishingDetail": "Ihre öffentliche Seite wird vorbereitet. Einen Moment bitte.",
  "editor.publish.successDetail": "Ihre öffentliche Seite ist aktuell und kann angesehen werden.",
  "editor.publish.viewPublic": "Öffentliche Seite ansehen",
  "editor.publish.cacheFailed": "aber das Schreiben des Caches für die öffentliche Seite ist fehlgeschlagen.",
  "editor.command.login": "Einloggen",
  "editor.handle.editTitle": "Öffentliche Adresse bearbeiten",
  "editor.handle.claimAfterPublish": "Wird erst beim Veröffentlichen reserviert",
  "editor.handle.claimAfterPublishTitle": "Diese Adresse wird nach der Veröffentlichung Ihr Eigentum",
  "editor.status.signedIn": "Angemeldet",
  "editor.status.account": "Konto: {email}",
  "editor.status.localTitle": "Lokaler Entwurf",
  "editor.status.localCopy": "Dieser Entwurf wird nur auf diesem Gerät gespeichert. Melden Sie sich an, um es mit der Cloud zu synchronisieren.",
  "editor.status.location": "Standort speichern",
  "editor.status.state": "Status speichern",
  "editor.status.emailLogin": "Email-Anmeldung",
  "editor.autosave.savingShort": "Wird gespeichert",
  "editor.autosave.savedCloudShort": "In der Cloud gespeichert",
  "editor.autosave.savedLocalShort": "Lokal gespeichert",
  "editor.autosave.failedShort": "Speichern fehlgeschlagen",
  "editor.autosave.signedInShort": "Angemeldet",
  "editor.autosave.cloud": "Wolke",
  "editor.autosave.retry": "Muss erneut versucht werden",
  "editor.autosave.device": "Dieses Gerät",
  "editor.autosave.saving": "Automatisches Speichern...",
  "editor.autosave.savedLocal": "Automatisch lokal gespeichert",
  "editor.autosave.savedCloud": "Automatisch in der Cloud gespeichert",
  "editor.autosave.authExpired": "Sitzung abgelaufen. Lokal gespeichert.",
  "editor.autosave.cloudFailed": "Cloud-Speicherung fehlgeschlagen. Lokal gespeichert.",
  "editor.autosave.cloudUnavailable": "Cloud-Speicherung ist noch nicht verbunden. Lokal gespeichert.",
  "editor.autosave.failed": "Automatisches Speichern fehlgeschlagen. Kopieren Sie Ihren Inhalt und versuchen Sie es erneut.",
  "editor.autosave.enabled": "Automatisches Speichern ist aktiviert",
  "identity.namePlaceholder": "Ihr Name",
  "identity.nameAria": "Name oder Spitzname",
  "identity.identityPlaceholder": "Einzeilige Identität",
  "identity.identityAria": "Einzeilige Identität",
  "identity.tagsAria": "Schlagworte",
  "identity.addTag": "Tag hinzufügen",
  "identity.removeTag": "Entfernen Sie das Tag {tag}",
  "body.emptyInstruction": "Schreibe auf, was jemand beim ersten Kennenlernen über dich wissen sollte.\nSchreibe weniger, damit das Wichtige gesehen wird. 30 Sekunden sind genau richtig.",
  "body.templatesLabel": "Du kannst auch mit einer Vorlage beginnen",
  "body.templatesAria": "Rollen-Vorlagen für den Text",
  "body.templateExampleLabel": "Beispielprofil",
  "body.viewTemplateExample": "Beispiel ansehen",
  "links.sectionAria": "Links",
  "links.documentTitle": "Links",
  "links.documentCopy": "Soziale Profile, Buchungs- und Kontaktdaten",
  "links.documentEmptyCopy": "Fügen Sie ein soziales Profil, eine Buchungsseite oder eine Kontaktmethode hinzu. Sie können sie jederzeit ändern.",
  "links.add": "Link hinzufügen",
  "links.addType": "Fügen Sie {label} hinzu",
  "links.edit": "Bearbeiten Sie {label}",
  "links.addedAria": "Links hinzugefügt",
  "links.closePanel": "Link-Editor schließen",
  "links.editTitle": "Link bearbeiten",
  "links.addTitle": "Link hinzufügen",
  "links.chooseTypeAgain": "Wählen Sie den Linktyp erneut aus",
  "links.calendarProvider": "Buchungsanbieter",
  "links.displayName": "Anzeigename",
  "links.duplicate": "{label} wurde bereits hinzugefügt.",
  "links.alreadyAdded": "{label} bereits hinzugefügt",
  "links.bookingAlreadyAdded": "Die Buchung wurde bereits hinzugefügt",
  "links.remove": "Löschen",
  "links.category.social": "Sozial",
  "links.category.booking": "Buchung",
  "links.category.work": "Arbeiten / Websites",
  "links.category.content": "Inhalt",
  "links.category.contact": "Kontakt",
  "links.category.other": "Andere",
  "links.type.x": "X",
  "links.type.github": "GitHub",
  "links.type.linkedin": "LinkedIn",
  "links.type.instagram": "Instagram",
  "links.type.youtube": "YouTube",
  "links.type.bilibili": "Bilibili",
  "links.type.xiaohongshu": "Xiaohongshu",
  "links.type.wechat": "Offizielles WeChat-Konto",
  "links.type.email": "Email",
  "links.type.calendar": "Buchung",
  "links.type.website": "Website",
  "links.type.newsletter": "Newsletter",
  "links.type.tiktok": "TikTok",
  "links.type.threads": "Threads",
  "links.type.mastodon": "Mastodon",
  "links.type.dribbble": "Dribbble",
  "links.type.jike": "Jike",
  "links.type.other": "Andere",
  "links.input.x": "X-Benutzername",
  "links.input.github": "GitHub-Benutzername",
  "links.input.linkedin": "LinkedIn URL",
  "links.input.instagram": "Instagram-Benutzername",
  "links.input.youtube": "YouTube-Benutzername",
  "links.input.bilibili": "Bilibili UID",
  "links.input.xiaohongshu": "Xiaohongshu-Profil URL",
  "links.input.wechat": "Offizielle WeChat-Konto-ID",
  "links.input.email": "Email",
  "links.input.calendar": "Buchungspfad",
  "links.input.website": "Website URL",
  "links.input.newsletter": "Newsletter URL",
  "links.input.tiktok": "TikTok-Benutzername",
  "links.input.threads": "Threads-Benutzername",
  "links.input.mastodon": "Mastodon URL",
  "links.input.dribbble": "Dribbble-Benutzername",
  "links.input.jike": "Jike-Profil URL",
  "links.input.other": "Link URL",
  "links.input.calendar.cal": "Cal.com-Pfad",
  "links.input.calendar.calendly": "Calendly Weg",
  "links.input.calendar.google": "Google Calendar Buchungsseite",
  "links.input.calendar.microsoft": "Microsoft Bookings-Link",
  "links.input.calendar.hubspot": "HubSpot Meetings-Link",
  "links.input.calendar.savvycal": "SavvyCal-Pfad",
  "links.input.calendar.tidycal": "TidyCal-Pfad",
  "links.input.calendar.zcal": "Zcal-Pfad",
  "links.hint.handle": "Geben Sie nur das Handle ein, kein URL.",
  "links.hint.uid": "Geben Sie nur UID ein, nicht das Profil URL.",
  "links.hint.slug": "Geben Sie nur den Pfad ein, nicht den vollständigen URL.",
  "links.hint.email": "Dadurch wird ein Mailto-Link erstellt.",
  "links.hint.text": "Durch Klicken auf die öffentliche Seite wird dieser Wert kopiert.",
  "links.hint.url": "Geben Sie einen gültigen https://-Link für diese Plattform ein.",
  "links.hint.calendarSlug": "Geben Sie nur den Benutzernamen oder Buchungspfad ein, nicht den vollständigen URL.",
  "links.hint.calendarUrl": "Geben Sie die vollständige Buchungsseite URL für diese Plattform ein.",
  "rich.toolbarAria": "Symbolleiste zur Textformatierung",
  "rich.heading": "Abschnittsüberschrift",
  "rich.paragraph": "Absatz",
  "rich.bold": "Deutlich",
  "rich.boldFallback": "fetter Text",
  "rich.italic": "Kursiv",
  "rich.italicFallback": "kursiver Text",
  "rich.code": "Inline-Code",
  "rich.comment": "Kommentar umschalten",
  "rich.ul": "Liste mit Aufzählungszeichen",
  "rich.ol": "Nummerierte Liste",
  "rich.link": "Link",
  "rich.linkPrompt": "Geben Sie einen https://- oder mailto:-Link ein",
  "rich.linkInvalid": "Links unterstützen nur https:// oder mailto:",
  "rich.linkFallback": "Linktext",
  "rich.aria": "30-sekündiger Einführungstext",
  "rich.more": "Weitere Formatierungen",
  "rich.quote": "Zitat",
  "rich.strikethrough": "Durchgestrichen",
  "rich.strikethroughFallback": "durchgestrichener Text",
  "rich.codeBlock": "Codeblock",
  "rich.codeBlockFallback": "Code",
  "rich.taskList": "Aufgabenliste",
  "rich.table": "Tabelle",
  "rich.tableSkeleton": "| Element | Beschreibung |\n| --- | --- |\n| Element eins | Beschreibung eins |\n| Element zwei | Beschreibung zwei |",
  "rich.indent": "Einzug vergrößern",
  "rich.outdent": "Einzug verkleinern",
  "rich.placeholder": "Schreiben Sie ein Markdown-Intro, das in 30 Sekunden gelesen werden kann ...",
  "feedback.aria": "Feedback schreiben",
  "feedback.timeTitle": "Geschätzte Lesezeit",
  "feedback.preview": "Vorschau",
  "feedback.previewMenu": "Vorschaumenü öffnen",
  "feedback.openAcceptancePreview": "Akzeptanzvorschau öffnen",
  "feedback.acceptancePreviewCopy": "Sehen Sie sich das Ergebnis der öffentlichen Seite auf diesem Gerät an",
  "feedback.noIssues": "Keine Blockierungsprobleme",
  "feedback.prePublish": "Schecks vor der Veröffentlichung",
  "feedback.ready": "Keine Blocker",
  "feedback.itemCount": "{count} Artikel",
  "feedback.valid": "Der Inhalt besteht die Veröffentlichungsprüfungen.",
  "issue.action.displayName": "Namen hinzufügen",
  "issue.action.oneLineIdentity": "Identität hinzufügen",
  "issue.action.tags": "Fügen Sie Tags hinzu",
  "issue.action.body": "Zurück zum Text",
  "issue.action.handle": "Adresse wählen",
  "issue.action.links": "Links verwalten",
  "issue.action.view": "Sicht",
  "issue.short.displayName": "Fehlender Name",
  "issue.short.oneLineIdentity": "Fehlende Identität",
  "issue.short.tags": "Fehlende Tags",
  "issue.short.handle": "Fehlende Adresse",
  "issue.short.readingTime": "Über 60 s",
  "issue.short.readingTimeLong": "Über 30 s",
  "issue.short.readingTimeShort": "Zu wenig Inhalt",
  "issue.short.bodyPlaceholder": "Beispielinhalt im Text",
  "issue.short.bodyFormat": "Textformat",
  "issue.short.links": "Linkproblem",
  "issue.short.linksEmpty": "Links können hinzugefügt werden",
  "issue.short.pending": "Braucht Arbeit",
  "issue.summary.more": "{count} zu reparierende Elemente",
  "publish.title.create": "Bestätigen Sie die Veröffentlichung",
  "publish.title.update": "Bestätigen Sie die Änderungen",
  "publish.action.create": "Veröffentlichen Sie auf 30s.to",
  "publish.action.update": "Änderungen veröffentlichen",
  "publish.closeAria": "Veröffentlichungsbestätigung schließen",
  "publish.address": "Öffentliche Adresse",
  "publish.unpublishedChanges": "Unveröffentlichte Änderungen",
  "publish.handleChanged": "Deine Adresse ändert sich von @{oldHandle} zu @{newHandle}. Die alte Adresse leitet 30 Tage lang weiter. Ab 180 Tagen nach der Änderung kann sie jemand anderem zugewiesen werden; alte Links können dann dessen Profil zeigen.",
  "publish.readingTime": "Lesezeit",
  "publish.status": "Status",
  "publish.ready": "Bereit",
  "publish.todo": "{count} Elemente, die verbessert werden müssen",
  "publish.visibility": "Veröffentlichungsart",
  "publish.visibility.indexed": "Suchmaschinen-Indexierung erlauben",
  "publish.visibility.unlisted": "Nur per Link",
  "publish.visibility.indexedNote": "Jeder kann die Seite sehen, und sie kann in Suchergebnissen erscheinen.",
  "publish.visibility.unlistedNote": "Jeder mit dem Link kann sie sehen; wir melden sie nicht bei Suchmaschinen an.",
  "publish.visibility.publicNote": "Beide Optionen sind öffentlich und der Link kann weitergegeben werden. Behalte den Entwurf, wenn nur du ihn sehen sollst.",
  "publish.publicContent": "Beim Veröffentlichen werden Name, Identität, Tags, Text und Links öffentlich. Autorenkommentare bleiben verborgen, sollten aber keine Geheimnisse enthalten.",
  "publish.noop": "Die öffentliche Seite ist bereits aktuell. Ändern Sie den Inhalt oder die Sichtbarkeit, bevor Sie ihn erneut veröffentlichen.",
  "publish.valid": "Der Inhalt besteht die Veröffentlichungsprüfungen.",
  "handleEdit.title": "Öffentliche Adresse bearbeiten",
  "handleEdit.label": "30s.to-Adresse",
  "handleEdit.help.changed": "Speichern ändert nur den Entwurf. Nach der Veröffentlichung leitet die alte Adresse 30 Tage weiter und kann nach 180 Tagen neu vergeben werden.",
  "handleEdit.help.saved": "Als Entwurf gespeichert. Die Verfügbarkeit wird bei der Veröffentlichung erneut überprüft.",
  "handleEdit.note": "Die aktuelle öffentliche Adresse lautet weiterhin 30s.to/@{handle}. Die neue Adresse wird nach der Veröffentlichung wirksam.",
  "handleEdit.save": "Als Entwurf speichern",
  "conflict.title": "Wählen Sie die Entwurfsversion",
  "conflict.copy": "Dieses Gerät und die Cloud verfügen beide über unveröffentlichte Inhalte. Ihre Auswahl wird zur nächsten zu bearbeitenden Version.",
  "conflict.useLocal": "Verwenden Sie lokalen Entwurf",
  "conflict.useLocalCopy": "Behalten Sie den aktuellen Seiteninhalt bei und synchronisieren Sie ihn mit der Cloud.",
  "conflict.useCloud": "Verwenden Sie Cloud Draft",
  "conflict.untitled": "Ohne Titel",
  "conflict.cloudVersion": "In der Cloud gespeicherte Version",
  "conflict.modifiedAt": "Zuletzt bearbeitet · {time}",
  "conflict.time.justNow": "gerade eben",
  "conflict.time.minutesAgo": "vor {count} Min.",
  "conflict.time.hoursAgo": "vor {count} Std.",
  "conflict.time.daysAgo": "vor {count} Tagen",
  "authModal.title": "Melden Sie sich bei 30s.to an",
  "authModal.copy": "Nach der Anmeldung werden Entwürfe mit der Cloud synchronisiert und die Veröffentlichung erfolgt zuverlässiger.",
  "login.page.eyebrow": "Konto",
  "login.page.title": "Melden Sie sich bei 30s.to an",
  "login.page.copy": "Synchronisieren Sie Entwürfe, veröffentlichen Sie öffentliche Seiten und verwalten Sie Einladungen.",
  "login.invalidEmail": "Geben Sie eine gültige E-Mail-Adresse ein.",
  "login.sendFailed": "Der Code konnte nicht gesendet werden.",
  "login.devCodeReady": "Lokaler Entwicklungscode generiert.",
  "login.codeSent": "Code gesendet. Überprüfen Sie Ihre E-Mails.",
  "login.networkSendFailed": "Der Code konnte nicht gesendet werden. Überprüfen Sie Ihre Verbindung.",
  "login.invalidCode": "Geben Sie den 6-stelligen Code ein.",
  "login.codeInvalid": "Der Code ist falsch oder abgelaufen.",
  "login.failed": "Fehler bei der Anmeldung. Versuchen Sie es später noch einmal.",
  "login.sendBusy": "Senden...",
  "login.resendCode": "Code erneut senden",
  "login.sendCode": "Code senden",
  "login.localCode": "Lokaler Entwicklungscode: {code}",
  "login.code": "Code",
  "login.codePlaceholder": "6 Ziffern",
  "login.inviteHelp": "Für die öffentliche Beta ist ein Einladungscode erforderlich. Durch die Verifizierung wird Ihr Konto aktiviert.",
  "login.verifyBusy": "Überprüfung...",
  "login.verifyInvite": "Bestätigen Sie die Einladung und melden Sie sich an",
  "login.verify": "Einloggen und fortfahren",
  "login.footnote": "Passwortlose Anmeldung. Neue Benutzer werden nach der E-Mail-Bestätigung mit einer Einladung aktiviert.",
  "login.google": "Weiter mit Google",
  "login.github": "Fahren Sie mit GitHub fort",
  "login.emailDivider": "oder E-Mail verwenden",
  "login.oauthFailed": "Die soziale Anmeldung wurde nicht abgeschlossen. Versuchen Sie es erneut oder verwenden Sie die E-Mail-Anmeldung.",
  "login.linkTitle": "Überprüfen Sie die E-Mail-Adresse des Kontos",
  "login.linkPageCopy": "Ein 30s.to-Konto verwendet diese E-Mail bereits. Wir verlinken es erst nach Überprüfung; Konten werden niemals automatisch zusammengeführt.",
  "login.linkCopy": "Wir senden einen Code an {email}. Die E-Mail kann hier nicht geändert werden.",
  "login.linkVerify": "Überprüfen und verknüpfen",
  "login.linkRequired": "Ein bestehendes Konto wurde gefunden. Bestätigen Sie die E-Mail-Adresse, um fortzufahren.",
  "login.activateTitle": "Aktivieren Sie 30s.to",
  "login.activatePageCopy": "Ihre soziale Identität wird überprüft. Es wird kein dauerhaftes Konto erstellt, bis die Einladung erfolgreich ist.",
  "login.activateCopy": "Für die öffentliche Beta ist eine Einladung erforderlich. Es wird erst eingelöst, wenn die Kontoerstellung erfolgreich ist.",
  "login.activationOpenCopy": "Die Registrierung ist geöffnet. Fahren Sie fort, um Ihr Konto zu aktivieren.",
  "login.activationClosedCopy": "Die Aktivierung neuer Konten ist pausiert. Bestehende Konten können sich weiterhin anmelden.",
  "login.activate": "Aktivieren und fortfahren",
  "login.inviteRequired": "Email verifiziert. Verwenden Sie zur Aktivierung eine Einladung.",
  "login.useEmailInstead": "Verwenden Sie stattdessen die E-Mail-Anmeldung",
  "preview.emptyEyebrow": "Vorschau",
  "preview.emptyTitle": "Kein Intro zur Vorschau verfügbar.",
  "preview.backToEdit": "Zurück zum Bearbeiten",
  "preview.edit": "Bearbeiten",
  "preview.localNoteAria": "Hinweis zur lokalen Vorschau",
  "preview.localNote": "Lokale Akzeptanz",
  "preview.localTitle": "Entwurfsvorschau auf diesem Gerät",
  "preview.themePicker": "Themenwechsler",
  "preview.themeGroup": "Wählen Sie ein Thema",
  "preview.themeFree": "Base",
  "preview.themePro": "Profi",
  "preview.mobileAria": "Vorschau der mobilen öffentlichen Seite",
  "preview.close": "Vorschau schließen",
  "preview.editorTitle": "Vorschau",
  "preview.publicTitle": "Vorschau der öffentlichen Seite",
  "preview.shareCardButton": "Themenkarte anzeigen",
  "preview.shareCardDialogTitle": "Vorschau der Themenkarte",
  "preview.shareCardTitle": "{theme}-Themenkarte",
  "preview.shareCardLogin": "Melden Sie sich an, um die echte Vorschau zu rendern",
  "preview.shareCardLoading": "Rendern der Themenkarte…",
  "preview.shareCardError": "Die Kartenvorschau ist vorübergehend nicht verfügbar",
  "preview.shareCardNote": "Die Themenkarte verwendet dieselbe visuelle Sprache wie die öffentliche Seite. Universalkarten sind in Dashboard erhältlich.",
  "public.copySuccess": "Kopiert {label}",
  "public.copyFailed": "Der Kopiervorgang ist fehlgeschlagen. Bitte manuell kopieren.",
  "public.createMine": "Erstelle mein Intro",
  "public.report": "Melden Sie diese Seite",
  "public.ownerAria": "Persönlicher Verwaltungseintrag",
  "public.owner.manage": "Verwalten",
  "public.owner.edit": "Bearbeiten",
  "public.status.unavailable": "Nicht verfügbar",
  "public.status.notFound": "404",
  "public.status.moderated": "Dieses 30-sekündige Intro ist nicht verfügbar.",
  "public.status.frozen": "Diese öffentliche Adresse ist nicht verfügbar.",
  "public.status.unpublished": "Dieses 30-sekündige Intro wurde noch nicht veröffentlicht.",
  "theme.footer": "Hergestellt mit 30s.to",
  "theme.fallback.name": "Ihr Name",
  "theme.fallback.nameUpper": "IHR NAME",
  "theme.fallback.nameNoir": "Name",
  "theme.fallback.nameIndex": "John Doe",
  "theme.fallback.identity": "Was machst du?",
  "theme.fallback.identityUpper": "IHRE EINZELNE IDENTITÄT UND MISSION",
  "theme.fallback.identityIndex": "Unbekannt",
  "theme.fallback.identityNoir": "Identität",
  "theme.fallback.terminalName": "Gast",
  "theme.fallback.terminalIntro": "Noch kein kurzes Intro",
  "theme.terminal.commandLabel": "Terminalbefehl",
  "theme.terminal.commandSubmit": "Befehl ausführen",
  "theme.terminal.outputLabel": "Interaktive Terminalausgabe",
  "theme.connect": "VERBINDEN",
  "theme.markdown.tableRegion": "Inhaltstabelle, horizontal scrollbar",
  "theme.markdown.task": "Aufgabe",
  "theme.tags": "TAGS",
  "theme.verified": "VERIFIZIERT",
  "theme.name": "NAME",
  "theme.identityLabel": "IDENTITÄT",
  "theme.keywords": "SCHLÜSSELWÖRTER",
  "theme.scroll": "Scrollen",
  "theme.pixel.previous": "Vorheriger Bildschirm",
  "theme.pixel.next": "Nächster Bildschirm",
  "theme.pixel.screen": "Bildschirm {current} von {total}",
  "theme.arcade.stage": "Stufe {current} / {total}",
  "theme.noise.reseed": "Nachsaatgeräusch",
  "theme.readingTime": "{seconds} Sek. Lesezeit",
  "theme.readingUnit": "Sek. Lesezeit",
  "theme.letter.greeting": "Hallo,",
  "theme.letter.signoff": "Herzliche Grüße",
  "theme.letter.postscript": "Hier findest du mich",
  "theme.letter.written": "Geschrieben am {date}",
  "dashboard.loginTitle": "Melden Sie sich an, um Ihr Intro zu verwalten.",
  "dashboard.loginAction": "Einloggen und verwalten",
  "dashboard.bannedTitle": "Dieses Konto ist derzeit nicht verfügbar.",
  "dashboard.bannedCopy": "Wenn Sie glauben, dass es sich hierbei um einen Fehler handelt, kontaktieren Sie uns über den Melde- und Einspruchseintrag.",
  "connections.kicker": "Konto",
  "connections.title": "Anmeldemethoden",
  "connections.settingsKicker": "Einstellungen",
  "connections.settingsTitle": "Konto und Verbindungen",
  "connections.settingsCopy": "Verwalte Anmeldeidentitäten und Zugriffe von Drittanbieter-Agents.",
  "connections.backToDashboard": "Zurück zur Übersicht",
  "connections.emailCode": "E-Mail-Bestätigungscode",
  "connections.alwaysAvailable": "Immer verfügbar",
  "connections.connect": "Verbinden",
  "connections.disconnect": "Entfernen Sie den 30s.to-Link",
  "connections.notConnected": "Nicht verbunden",
  "connections.noEmail": "Keine E-Mail-Adresse angegeben",
  "connections.emailVerified": "Email verifiziert",
  "connections.connected": "Verbunden",
  "connections.unavailable": "Nicht aktiviert",
  "connections.confirm": "Den {provider}-Link von 30s.to entfernen? Email-Login bleibt verfügbar.",
  "connections.removed": "Der Identitätslink wurde aus 30s.to entfernt.",
  "connections.failed": "Anmeldemethoden konnten nicht aktualisiert werden. Versuchen Sie es später noch einmal.",
  "connections.help": "Dadurch wird lediglich die 30s.to-Identitätszuordnung entfernt. Der Anbieterzugriff wird dadurch nicht widerrufen. Anbieterzugriff verwalten:",
  "agentConnections.kicker": "Agent",
  "agentConnections.title": "Agent-Verbindungen",
  "agentConnections.copy": "Installiere ein Skill, damit deine bevorzugten Agents Informationen sammeln, Texte entwerfen und deinen 30s.to-Entwurf sicher aktualisieren.",
  "agentConnections.addTitle": "Neuen Agent verbinden",
  "agentConnections.addCopy": "Verbindungs-URL und Einrichtungsschritte anzeigen",
  "agentConnections.examplesDisclosure": "Anwendungsbeispiele anzeigen",
  "settings.title": "Einstellungen",
  "settings.copy": "Verwalte Konto, Sicherheit, externe Verbindungen und deinen 30s.to-Tarif.",
  "settings.navAria": "Einstellungskategorien",
  "settings.account.title": "Konto",
  "settings.account.copy": "Deine 30s.to-Identität und der Zugang zu deinem Profil.",
  "settings.account.email": "Konto-E-Mail",
  "settings.account.profile": "Profil",
  "settings.account.plan": "Aktueller Tarif",
  "settings.account.manageProfile": "Profil verwalten",
  "settings.login.copy": "Verwalte die Identitäten, mit denen du dich bei 30s.to anmelden kannst.",
  "settings.billing.copy": "Prüfe deinen aktuellen Tarif, die Verlängerung und den Zugang zur Abrechnung.",
  "settings.invites.copy": "Verwalte dein Public-Beta-Einladungskontingent und die letzten Codes.",
  "agentConnections.endpoint": "Verbindungs-URL",
  "agentConnections.copyAction": "Kopieren",
  "agentConnections.copied": "Kopiert",
  "agentConnections.copyFailed": "Kopieren nicht möglich. Kopiere die URL manuell.",
  "agentConnections.endpointCopied": "Verbindungs-URL kopiert.",
  "agentConnections.stepsAria": "Schritte zum Verbinden eines Agents",
  "agentConnections.step1": "Füge in den MCP- oder Connector-Einstellungen deines Agents einen Remote-Dienst hinzu.",
  "agentConnections.step2": "Füge die Verbindungs-URL ein, melde dich bei 30s.to an und erlaube den Zugriff.",
  "agentConnections.step3": "Sage dem Agent, was er ändern soll, und prüfe den Entwurf anschließend auf 30s.to.",
  "agentConnections.examplesTitle": "Beispielanfragen",
  "agentConnections.exampleFirst": "Lies mein 30s.to-Profil und die Formatregeln und hilf mir, mein erstes Intro fertigzustellen.",
  "agentConnections.exampleSection": "Behalte meinen Ton bei und schreibe nur den Abschnitt „Jetzt“ neu.",
  "agentConnections.exampleShorten": "Kürze das gesamte Intro auf unter 30 Sekunden. Veröffentliche es nicht.",
  "agentConnections.copyExample": "Beispiel {number} kopieren",
  "agentConnections.promptCopied": "Beispielanfrage kopiert.",
  "agentConnections.boundary": "Agents können nur Entwürfe lesen und aktualisieren. Sie können nicht für dich veröffentlichen oder die Veröffentlichung stoppen.",
  "agentConnections.authorizedTitle": "Autorisierte Verbindungen",
  "agentConnections.empty": "Noch keine Agents autorisiert.",
  "agentConnections.disabled": "Agent-Verbindungen sind noch nicht aktiviert.",
  "agentConnections.scopeRead": "Entwurf lesen",
  "agentConnections.scopeWrite": "Entwurf aktualisieren",
  "agentConnections.connectedAt": "Verbunden am {date}",
  "agentConnections.selfReported": "Der Clientname wird vom Client selbst angegeben",
  "agentConnections.revoke": "Widerrufen",
  "agentConnections.confirm": "Verbindung zu {client} widerrufen? Danach kann der Client nicht mehr auf deinen 30s.to-Entwurf zugreifen.",
  "agentConnections.confirmSkill": "Verbindung zum 30s.to Skill widerrufen? Lokale Agents, die dieses Skill verwenden, werden von 30s.to abgemeldet.",
  "agentConnections.revoked": "Agent-Verbindung widerrufen.",
  "agentConnections.failed": "Agent-Verbindungen konnten nicht aktualisiert werden. Versuche es später erneut.",
  "agentConnections.manualTitle": "Remote MCP manuell verbinden",
  "agentConnections.manualCopy": "Erweitert: Einen Remote-MCP-kompatiblen Client separat autorisieren",
  "skill.meta.title": "30s.to Skill — Lass deinen Agent deine Vorstellung schreiben",
  "skill.meta.description": "Teile deine Website, Projekte oder dein Portfolio. Agent recherchiert deine Arbeit und interviewt dich für deine 30-Sekunden-Vorstellung.",
  "skill.kicker": "30s.to Skill",
  "skill.title": "Deine Vorstellung,\nmit deinem Agenten.",
  "skill.copy": "Gib ihm ein paar Links. Dein Agent lernt dich kennen und hilft dir, eine Vorstellung für 30 Sekunden Lesezeit zu schreiben.",
  "skill.processTitle": "So hilft Agent beim Schreiben",
  "skill.process.clues.title": "Links teilen",
  "skill.process.clues.copy": "Dein öffentliches Profil, deine Projektwebsite oder dein Portfolio.",
  "skill.process.research.title": "Gründliche Recherche, dann Interview",
  "skill.process.research.copy": "Er untersucht deine Website, Projekte und Arbeiten gründlich, ordnet die wichtigsten Punkte und klärt offene Fragen im Interview mit dir.",
  "skill.process.profile.title": "Agent schreibt deine Vorstellung",
  "skill.process.profile.copy": "Ihr feilt gemeinsam an Inhalt und Ton, bis die Vorstellung nach dir klingt.",
  "skill.installTitle": "In deinem Agent installieren",
  "skill.installCopy": "Kopiere die Anweisung, füge sie in deinen gewohnten Agenten ein und sende sie ab.",
  "skill.promptLabel": "Installationsanweisung",
  "skill.copyPrompt": "Installationsanweisung kopieren",
  "skill.promptCopied": "Installationsanweisung kopiert. Öffne jetzt den Agent, den du verwendest, füge die Anweisung ein und sende sie ab.",
  "skill.copyFailed": "Kopieren nicht möglich. Wähle die Installationsanweisung unten aus und kopiere sie.",
  "skill.startTitle": "So startest du",
  "skill.start.install": "30s.to Skill installieren",
  "skill.start.chat": "Gespräch beginnen",
  "skill.start.chatCopy": "Öffne nach der Installation einen neuen Chat und schreibe:",
  "skill.start.prompt": "Hilf mir mit 30s.to, meine Vorstellung zu schreiben.",
  "dashboard.kicker": "Mein Intro",
  "dashboard.defaultTitle": "Mein 30-sekündiges Intro",
  "dashboard.primaryEdit": "Bearbeiten Sie weiter",
  "dashboard.primaryCreate": "Beginnen Sie mit dem Erstellen",
  "dashboard.unpublished": "Nicht veröffentlicht",
  "dashboard.unselected": "Nicht ausgewählt",
  "dashboard.confirmDiscard": "Unveröffentlichte Änderungen verwerfen und die aktuelle öffentliche Version wiederherstellen?",
  "dashboard.discardFailed": "Änderungen konnten nicht verworfen werden.",
  "dashboard.discardConflict": "Dieser Entwurf wurde an anderer Stelle geändert. Aktualisieren und prüfen Sie die Seite, bevor Sie es erneut versuchen.",
  "dashboard.discardNetworkFailed": "Änderungen konnten nicht verworfen werden. Versuchen Sie es später noch einmal.",
  "dashboard.discardDone": "Auf die aktuelle öffentliche Version zurückgesetzt.",
  "dashboard.statusAria": "Aktueller Stand",
  "dashboard.versionAria": "Versionsbeziehung",
  "dashboard.publicPage": "Öffentliche Seite",
  "dashboard.indexingAllowed": "Indexierung erlaubt",
  "dashboard.indexingBlocked": "Nur per Link",
  "dashboard.publicVersion": "Veröffentlichte Version",
  "dashboard.invisible": "Für andere noch nicht sichtbar",
  "dashboard.draft": "Entwurf",
  "dashboard.currentDraft": "Aktuelle editierbare Version",
  "dashboard.draftSynced": "Synchronisiert mit der öffentlichen Seite",
  "dashboard.editableVersionEmpty": "Bearbeitbare Version · Nicht erstellt",
  "dashboard.editableVersionDirty": "Bearbeitbare Version · Änderungen nicht veröffentlicht",
  "dashboard.editableVersionSynced": "Bearbeitbare Version · Entspricht der öffentlichen Seite",
  "dashboard.editableVersionUnpublished": "Bearbeitbare Version · Nicht veröffentlicht",
  "dashboard.betaActive": "Aktiv",
  "dashboard.betaInactive": "Inaktiv",
  "dashboard.adminCanPublish": "Das Administratorkonto kann veröffentlichen",
  "dashboard.betaAccessNote": "Zugang zur Veröffentlichung der öffentlichen Beta",
  "dashboard.visibility": "Sichtbarkeit",
  "dashboard.chooseOnPublish": "Wählen Sie diese Option während der Veröffentlichungsbestätigung aus",
  "dashboard.snapshot": "Schnappschuss",
  "dashboard.snapshotAfterPublish": "Nach der Veröffentlichung wird ein Schnappschuss der öffentlichen Seite erstellt",
  "dashboard.publishDetailsAria": "Veröffentlichungsdetails",
  "dashboard.actionsAria": "Managementmaßnahmen",
  "dashboard.nextAction": "Nächster Schritt",
  "dashboard.openPublicPage": "Öffentliche Seite öffnen",
  "dashboard.changeVisibility": "Veröffentlichungsart ändern",
  "dashboard.unpublish": "Veröffentlichung stoppen",
  "dashboard.unpublishTitle": "Veröffentlichung stoppen?",
  "dashboard.unpublishDescription": "Die öffentliche Seite ist sofort nicht mehr erreichbar. Entwurf und öffentliche Adresse bleiben erhalten, damit du später erneut veröffentlichen kannst.",
  "dashboard.unpublishWarning": "Bereits von Suchmaschinen oder anderen Personen gespeicherte Kopien verschwinden möglicherweise nicht sofort.",
  "dashboard.unpublishConfirm": "Veröffentlichung stoppen",
  "dashboard.unpublishBusy": "Wird gestoppt...",
  "dashboard.unpublishSuccess": "Die öffentliche Seite ist nicht mehr erreichbar. Entwurf und öffentliche Adresse wurden beibehalten.",
  "dashboard.unpublishFailed": "Die Veröffentlichung konnte nicht gestoppt werden. Versuche es später erneut.",
  "dashboard.discardBusy": "Wiederherstellung...",
  "dashboard.discard": "Änderungen verwerfen",
  "dashboard.metricsAria": "Leichte Daten",
  "dashboard.views": "Ansichten",
  "dashboard.clicks": "Klicks",
  "dashboard.readingTime": "Lesezeit",
  "dashboard.theme": "Thema",
  "dashboard.noTheme": "Nicht ausgewählt",
  "dashboard.visibility.indexed": "Suchmaschinen-Indexierung erlauben",
  "dashboard.visibility.unlisted": "Nur per Link",
  "dashboard.visibility.indexedNote": "Kann in Suchergebnissen erscheinen",
  "dashboard.visibility.unlistedNote": "Bleibt für jeden mit dem direkten Link sichtbar",
  "dashboard.snapshot.ready": "Cache bereit",
  "dashboard.snapshot.failed": "D1-Fallback",
  "dashboard.snapshot.none": "Nicht generiert",
  "dashboard.snapshot.readyNote": "Öffentlicher Schnappschuss an KV geschrieben",
  "dashboard.snapshot.failedNote": "Die öffentliche Seite funktioniert weiterhin über den D1-Fallback",
  "dashboard.snapshot.noneNote": "Für die aktuell veröffentlichte Version ist kein Snapshot verfügbar",
  "invite.title": "Laden Sie Freunde zur öffentlichen Beta ein",
  "invite.remaining": "Diesen Monat sind noch Einladungen für {remaining} / {quota} verfügbar.",
  "invite.generateFailed": "Einladung konnte nicht generiert werden.",
  "invite.generated": "{count} Einladungscodes wurden erstellt. Sie werden nur dieses Mal angezeigt.",
  "invite.quotaUsed": "Monatliches Einladungskontingent verwendet.",
  "invite.generating": "Generieren...",
  "invite.generate": "Alle {count} verbleibenden erstellen",
  "invite.batchTitle": "Jetzt erstellte Einladungscodes: {count}",
  "invite.copyAll": "Alle Codes kopieren",
  "invite.copiedAll": "Alle Codes kopiert",
  "invite.copyMessage": "Teilen-Text kopieren",
  "invite.messageCopied": "Teilen-Text kopiert",
  "invite.share": "Direkt teilen",
  "invite.shared": "Teilen-Dialog geöffnet.",
  "invite.shareFallback": "Direktes Teilen ist nicht verfügbar; der Text wurde kopiert.",
  "invite.shareFailed": "Teilen nicht möglich. Kopiere stattdessen den Text.",
  "invite.shareMessage": "Ich nutze 30s.to für eine persönliche 30-Sekunden-Vorstellung. Probier es auch aus.\n\nEinladungscodes:\n{codes}\n\nÖffne {url}, um loszulegen.",
  "invite.recentAria": "Nutzungsstatus der Einladungscodes",
  "invite.statusTitle": "Nutzungsstatus",
  "invite.statusSummary": "{active} verfügbar · {redeemed} verwendet · {expired} abgelaufen · {revoked} widerrufen",
  "invite.status.revoked": "Widerrufen",
  "invite.status.redeemed": "Gebraucht",
  "invite.status.expired": "Abgelaufen",
  "invite.status.active": "Verfügbar",
  "invite.copy": "Kopie",
  "invite.copied": "Kopiert",
  "invite.showOnce": "Nur einmal angezeigt",
  "invite.expiryUnknown": "Ablauf unbekannt",
  "invite.expiresAt": "Läuft am {date} ab",
  "management.handlePending.title": "Adressänderung steht aus",
  "management.handlePending.description": "Die aktuelle öffentliche Adresse ist immer noch {publishedAddress}. Durch die Veröffentlichung wird {draftAddress} aktiviert.",
  "management.handlePending.next": "Veröffentlichen Sie Änderungen, bevor {draftAddress} zur öffentlichen Adresse wird.",
  "management.dirty.title": "Unveröffentlichte Änderungen",
  "management.dirty.description": "Ihr Entwurf wurde nicht auf der öffentlichen Seite veröffentlicht.",
  "management.dirty.next": "Veröffentlichen Sie Änderungen, um die öffentliche Seite mit diesem Entwurf zu synchronisieren.",
  "management.published.title": "Veröffentlicht",
  "management.published.description": "Die öffentliche Seite ist aktuell.",
  "management.published.next": "Die öffentliche Seite wird synchronisiert. Fahren Sie mit der Bearbeitung fort, wenn Sie es anpassen möchten.",
  "management.unpublished.title": "Unveröffentlicht",
  "management.unpublished.description": "Dieses Intro ist immer noch nur als Entwurf gespeichert.",
  "management.unpublished.next": "Veröffentliche die Seite, bevor andere die öffentliche Adresse aufrufen können.",
  "management.empty.title": "Noch kein Intro",
  "management.empty.description": "Wählen Sie eine Adresse und schreiben Sie ein 30-sekündiges Intro.",
  "management.empty.next": "Erstellen Sie zunächst einen Entwurf. Prüfungen vor der Veröffentlichung bleiben im Editor.",
  "management.publish.create": "Einführung veröffentlichen",
  "management.publish.update": "Änderungen veröffentlichen",
  "abuse.kicker": "Vertrauen und Sicherheit",
  "abuse.title": "Berichtsseite",
  "abuse.copy": "Berichte werden nur zur Sicherheitsüberprüfung verwendet. Ihre Identität ist nicht öffentlich.",
  "abuse.missingHandle": "Fehlendes Berichtsziel.",
  "abuse.done": "Bericht erhalten. Wir werden es bald überprüfen.",
  "abuse.failed": "Die Übermittlung ist fehlgeschlagen. Versuchen Sie es später noch einmal.",
  "abuse.reason.spam": "Spam",
  "abuse.reason.impersonation": "Identitätswechsel",
  "abuse.reason.abuse": "Belästigung oder Hass",
  "abuse.reason.illegal": "Illegale Inhalte",
  "abuse.reason.other": "Anderes Problem",
  "abuse.submitBusy": "Wird gesendet…",
  "abuse.submit": "Bericht absenden",
  "terms.title": "Nutzungsbedingungen",
  "privacy.title": "Datenschutzhinweis",
  "validation.handle.required": "Geben Sie einen Handle ein.",
  "validation.handle.invalid": "Das Handle muss aus 4–24 englischen Kleinbuchstaben bestehen.",
  "validation.handle.reserved": "Diese öffentliche Adresse ist nicht verfügbar. Versuche es mit einer anderen.",
  "validation.handle.unavailable": "Diese öffentliche Adresse ist nicht verfügbar. Versuche es mit einer anderen.",
  "validation.handle.frozen": "Diese öffentliche Adresse ist nicht verfügbar. Versuche es mit einer anderen.",
  "validation.handle.protected": "Diese öffentliche Adresse ist nicht verfügbar. Versuche es mit einer anderen.",
  "validation.handle.checkFailed": "Wir konnten diese Adresse nicht bestätigen.",
  "validation.handle.changeLimit": "Sie können Ihre öffentliche Adresse nur einmal alle 30 Tage ändern.",
  "validation.displayName.required": "Name oder Spitzname ist erforderlich.",
  "validation.identity.required": "Eine einzeilige Identität ist erforderlich.",
  "validation.tags.range": "Fügen Sie 1–5 Tags hinzu.",
  "validation.links.limit": "Sie können bis zu {limit} eigenständige Links hinzufügen.",
  "validation.links.empty": "Noch keine Links. Sie können ein soziales Profil, eine Buchungsseite oder eine Kontaktmethode hinzufügen.",
  "validation.input.tooLong": "Die Eingabe darf höchstens {limit} Zeichen lang sein.",
  "validation.body.placeholder": "Der Text enthält noch {detail}. Ersetze es durch echten Inhalt oder lösche es.",
  "validation.body.oldTemplate": "die frühere Textvorlage",
  "validation.body.readingTime": "Die geschätzte Lesezeit beträgt {seconds} Sekunden. Kürze den Text auf höchstens {maximum} Sekunden.",
  "validation.body.readingTimeLong": "Die geschätzte Lesezeit beträgt {seconds} Sekunden und liegt damit über den empfohlenen {recommended} Sekunden. Die Veröffentlichung ist weiterhin möglich.",
  "validation.body.readingTimeShort": "Die geschätzte Lesezeit beträgt {seconds} Sekunden. Ergänze Inhalt, bis mindestens {minimum} Sekunden erreicht sind.",
  "validation.markdown.h1": "# Überschriften auf Seitenebene werden nicht unterstützt",
  "validation.markdown.deepHeading": "### und tiefere Überschriften werden nicht unterstützt",
  "validation.markdown.image": "Bildsyntax wird nicht unterstützt",
  "validation.markdown.codeBlock": "Codeblöcke werden nicht unterstützt",
  "validation.markdown.taskList": "Aufgabenlisten werden nicht unterstützt",
  "validation.markdown.table": "Tabellen werden nicht unterstützt",
  "validation.markdown.footnote": "Fußnoten werden nicht unterstützt",
  "validation.markdown.html": "HTML und Einbettungen werden nicht unterstützt",
  "validation.markdown.commentUnclosed": "Dem Kommentar fehlt die Endmarkierung -->",
  "validation.markdown.commentStrayClose": "Dem Kommentar fehlt die Startmarkierung <!--",
  "validation.markdown.commentNested": "Verschachtelte <!-- --> Kommentare werden nicht unterstützt",
  "validation.markdown.nestedHeading": "Abschnittsüberschriften müssen auf Dokumentebene stehen",
  "validation.markdown.setextHeading": "Setext-Überschriften werden nicht unterstützt",
  "validation.markdown.headingInline": "Abschnittsüberschriften dürfen nur Klartext enthalten",
  "validation.markdown.frontmatter": "Frontmatter wird nicht unterstützt",
  "validation.markdown.indentedCode": "Eingerückte Codeblöcke werden nicht unterstützt; verwende einen abgegrenzten Codeblock",
  "validation.markdown.codeFenceUnclosed": "Dem Codeblock fehlt die schließende Markierung",
  "validation.markdown.codeLanguage": "Sprachangaben erlauben 1–32 Buchstaben, Zahlen, _, + oder -",
  "validation.markdown.listDepth": "Listen unterstützen bis zu drei Ebenen",
  "validation.markdown.tableSize": "Tabellen unterstützen bis zu 6 Spalten und 20 Zeilen",
  "validation.markdown.linkProtocol": "Textlinks unterstützen nur HTTPS und E-Mail",
  "validation.link.unsupportedType": "Dieser Linktyp wird noch nicht unterstützt. Wählen Sie einen Website-, Plattform- oder Buchungslink.",
  "validation.link.labelRequired": "Der Linkname darf nicht leer sein.",
  "validation.link.providerRequired": "Wählen Sie eine Buchungsplattform.",
  "validation.link.valueRequired": "{label} darf nicht leer sein.",
  "validation.link.httpsOnly": "Links unterstützen nur https://.",
  "validation.link.invalid": "Geben Sie einen gültigen Link ein.",
  "validation.link.validEmail": "Geben Sie eine gültige E-Mail-Adresse ein.",
  "validation.link.validGithub": "Geben Sie ein gültiges GitHub-Handle ein.",
  "validation.link.validBilibili": "Geben Sie einen gültigen Bilibili UID ein.",
  "validation.link.validXiaohongshu": "Geben Sie einen gültigen Xiaohongshu-Profillink ein.",
  "validation.link.validGoogleCalendar": "Geben Sie einen gültigen Google Calendar-Buchungslink ein.",
  "validation.link.validMicrosoftBookings": "Geben Sie einen gültigen Microsoft Bookings-Link ein.",
  "validation.theme.proRequired": "Für die Veröffentlichung dieses Themas ist 30s Pro erforderlich.",
  "validation.link.validHubSpot": "Geben Sie einen gültigen HubSpot Meetings-Link ein.",
  "validation.account.banned": "Dieses Konto kann derzeit nicht veröffentlicht werden.",
  "validation.account.login": "Melde dich zuerst an.",
  "validation.account.invite": "Aktiviere dein Konto zuerst mit einem Einladungscode.",
  "validation.publish.failed": "Die Veröffentlichung ist fehlgeschlagen. Versuchen Sie es später noch einmal.",
  "validation.turnstile.required": "Schließe die Sicherheitsprüfung ab.",
  "validation.report.missing": "Die zu meldende Seite fehlt.",
  "validation.report.reason": "Wähle einen Meldegrund.",
  "validation.report.notReportable": "Diese Seite kann derzeit nicht gemeldet werden.",
  "common.listSeparator": ",",
  "dashboard.section.status": "Status",
  "dashboard.section.performance": "Leistung",
  "dashboard.fullAnalytics": "Vollständige Analyse anzeigen",
  "dashboard.shareCard": "Karte teilen",
  "dashboard.timestamp.notPublished": "Nicht veröffentlicht",
  "dashboard.timestamp.notEdited": "Nicht bearbeitet",
  "dashboard.timestamp.published": "Veröffentlicht {date} UTC",
  "dashboard.timestamp.edited": "Bearbeitet {date} UTC",
  "upgrade.publishTheme": "Veröffentlichen Sie {theme}",
  "upgrade.copy": "Deine Auswahl ist gespeichert und bleibt vollständig in der Vorschau sichtbar. Nach dem Upgrade kannst du ohne erneute Bearbeitung veröffentlichen.",
  "upgrade.benefit.themes": "Veröffentlichen Sie jedes Premium-Theme",
  "upgrade.benefit.analytics": "Siehe Lesezeit und Fertigstellung",
  "upgrade.benefit.cards": "Mit Social OG synchronisierte Themenkarten",
  "upgrade.seePro": "Siehe 30s Pro",
  "upgrade.keepEditing": "Bearbeiten Sie weiter",
  "pro.meta.title": "30s Pro – Zeig dich unverwechselbar",
  "pro.meta.description": "Premium-Themes, echte Leseanalyse und passende Share-Cards machen dein 30-Sekunden-Intro noch persönlicher.",
  "pro.title": "Zeig dich unverwechselbar.",
  "pro.intro": "Noch immer in 30 Sekunden gelesen. Pro gibt dir mehr Ausdruck, klareres Feedback und fertige Inhalte zum Teilen.",
  "pro.priceAction": "Founding Price ansehen",
  "pro.summaryAria": "Zusammenfassung der Pro-Vorteile",
  "pro.summaryThemes": "Premium-Themen",
  "pro.summaryAnalytics": "Tage Analyse",
  "pro.summaryShare": "mit deiner Karte synchron",
  "pro.benefitsKicker": "Pro-Werkzeuge",
  "pro.benefitsTitle": "Vom Ausdruck zur Wirkung.",
  "pro.benefit.themes.title": "Premium-Themen",
  "pro.benefit.themes.body": "Acht Themes, angeführt von Terminal. In Free kannst du alle ansehen, mit Pro veröffentlichst du deinen Favoriten.",
  "pro.benefit.analytics.title": "Lesequalität",
  "pro.benefit.analytics.body": "Mehr als Aufrufe: aktive Lesezeit, Abschlussrate, Lesefortschritt, Trends über 30, 90 und 365 Tage sowie Link-CTR.",
  "pro.benefit.share.title": "Teilen, wie es zu dir passt",
  "pro.benefit.share.body": "Free enthält eine schlichte Karte mit Name und Link. Pro ergänzt zwei universelle Karten und eine eigene für jedes Theme. Deine Auswahl wird auch zum OG-Bild und lässt sich mit integriertem QR direkt teilen oder laden.",
  "pro.benefit.attribution.title": "Nur du",
  "pro.benefit.attribution.body": "Blende den 30s.to-Hinweis im Theme aus. Notwendige Funktionen für Meldungen und Sprache bleiben erhalten.",
  "pro.pricingTitle": "Früh dabei. Dauerhaft einfach.",
  "pro.pricingBody": "Solange dein Abo läuft, behältst du den Founding Price. Nach einer Kündigung gilt bei einem Neuabschluss der dann aktuelle Preis.",
  "pro.terminalAria": "Vorschau des Terminal Pro-Themas",
  "pro.checkout.continuous": "Preis bleibt bei laufendem Abo erhalten",
  "pro.checkout.intervalAria": "Abrechnungsintervall",
  "pro.checkout.monthly": "Monatlich",
  "pro.checkout.yearly": "Jährlich",
  "pro.checkout.save": "$16 sparen",
  "pro.checkout.periodYear": "Jahr",
  "pro.checkout.periodMonth": "Monat",
  "pro.checkout.annualNote": "Entspricht ${price} pro Monat – 44 % weniger als monatliche Zahlung.",
  "pro.checkout.monthlyNote": "Monatlich zahlen und jederzeit zum Ende des Zeitraums kündigen.",
  "pro.checkout.includeThemes": "Alle Premium-Themen",
  "pro.checkout.includeAnalytics": "Lesequalität und 365-Tage-Analyse",
  "pro.checkout.includeCards": "Themenkarten, QR und OG",
  "pro.checkout.includeAttribution": "30s.to-Hinweis im Theme ausblenden",
  "pro.checkout.manage": "Mein Pro-Abo verwalten",
  "pro.checkout.comingSoon": "Zahlung bald verfügbar",
  "pro.checkout.signIn": "Anmelden und upgraden",
  "pro.checkout.inviteRequired": "Beta-Einladung erforderlich",
  "pro.checkout.opening": "Sicherer Checkout wird geöffnet…",
  "pro.checkout.upgrade": "Upgrade auf 30s Pro",
  "pro.checkout.footnote": "Sichere Zahlung mit Creem. Steuern werden vorab angezeigt; keine Testphase, automatische Verlängerung.",
  "pro.checkout.unavailable": "Die Zahlung kann gerade nicht geöffnet werden. Versuch es später erneut.",
  "pro.checkout.networkError": "Die Verbindung ist fehlgeschlagen. Versuch es später erneut.",
  "billing.panelAria": "Pro und Abrechnung",
  "billing.plan": "Tarif",
  "billing.status.canceling": "Kündigung vorgemerkt",
  "billing.status.pastDue": "Zahlung überfällig",
  "billing.status.active": "Aktiv",
  "billing.status.free": "Kostenlos",
  "billing.yearly": "Jährlich",
  "billing.monthly": "Monatlich",
  "billing.basicPlan": "Kostenloser Tarif",
  "billing.ends": "Endet am {date}",
  "billing.renews": "Verlängert sich am {date}",
  "billing.graceEnds": "Die Nachfrist endet: {date}",
  "billing.anomaly": "Ihr Abrechnungsstatus muss manuell überprüft werden. Kontaktieren Sie support@30s.to.",
  "billing.opening": "Abrechnung wird geöffnet",
  "billing.manage": "Abrechnung verwalten",
  "billing.upgrade": "Upgrade auf Pro",
  "billing.openingHistory": "Abrechnungsverlauf wird geöffnet…",
  "billing.viewHistory": "Abrechnungsverlauf anzeigen",
  "billing.portalUnavailable": "Die Abrechnungsverwaltung ist vorübergehend nicht verfügbar.",
  "billing.networkError": "Netzwerkverbindung fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "billingReturn.kicker": "30s Pro · Zahlungsbestätigung",
  "billingReturn.activeTitle": "Pro ist jetzt aktiv",
  "billingReturn.failedTitle": "Die Zahlung ist noch nicht bestätigt",
  "billingReturn.waitingTitle": "Bestätigen Sie Ihre Zahlung",
  "billingReturn.failedCopy": "Möglicherweise wird Ihre Zahlung noch synchronisiert. Überprüfen Sie das Dashboard später noch einmal. Der Zugriff wird niemals allein über die Rückkehrseite gewährt.",
  "billingReturn.waitingCopy": "Wir prüfen Ihr Abonnement beim Zahlungsanbieter. Lassen Sie diese Seite geöffnet.",
  "billingReturn.back": "Zurück zum Dashboard",
  "analytics.kicker": "30s Pro · Analytics",
  "analytics.nav": "Analyse",
  "analytics.title": "Vom Besuch bis zum vollständigen Lesen.",
  "analytics.copy": "Sieh den Weg vom Besuch bis zum vollständigen Lesen und zu Link-Klicks, ohne Personen zu tracken. Datumsangaben und Deduplizierung basieren auf UTC.",
  "analytics.rangeAria": "Datumsbereich",
  "analytics.days": "{count} Tage",
  "analytics.uniqueVisitors": "Eindeutige Besucher",
  "analytics.rangeTotal": "Summe für {count} Tage",
  "analytics.averageReading": "Ø aktive Lesezeit",
  "analytics.activeReadingNote": "Zeit, in der die Seite sichtbar und aktiv war",
  "analytics.completionRate": "Abschlussrate",
  "analytics.completedVisitors": "{count} Besucher haben bis zum Ende gelesen",
  "analytics.overallCtr": "Gesamt-CTR",
  "analytics.engagedVisitors": "{count} engagierte Besucher",
  "analytics.trafficTrend": "Verkehrstrend",
  "analytics.dailyTrendAria": "Täglicher Verlauf der eindeutigen Besucher",
  "analytics.readingCompletion": "Leseabschluss",
  "analytics.dailyMaximum": "Besucher / Tag max",
  "analytics.visitorCount": "{count} Besucher",
  "analytics.topLinks": "Top-Links",
  "analytics.uniqueClickers": "Personen mit Link-Klick",
  "analytics.linkTrendAria": "Tagestrend für {label}",
  "analytics.noInteractions": "Noch keine Link-Interaktionen.",
  "analytics.audienceOverview": "Zielgruppenübersicht",
  "analytics.pageLevel": "Seitenebene",
  "analytics.referrers": "Zugriffsquellen",
  "analytics.devices": "Geräte",
  "analytics.countries": "Länder",
  "analytics.noData": "Noch keine Daten",
  "analytics.durationSeconds": "{seconds}s",
  "analytics.durationMinutes": "{minutes} Min. {seconds} Sek.",
  "share.card": "Share-Karte",
  "share.variant.classic": "Klassisch",
  "share.variant.classicNote": "Ruhig",
  "share.variant.contact": "Index",
  "share.variant.contactNote": "Strukturiert",
  "share.variant.theme": "{theme}-Edition",
  "share.variant.themeNote": "Thema",
  "share.variant.universal": "Universell",
  "share.saveFailed": "Konnte nicht gespeichert werden",
  "share.styleUpdated": "Stil aktualisiert",
  "share.networkError": "Netzwerkverbindung fehlgeschlagen",
  "share.linkCopied": "Link kopiert",
  "share.copyFailed": "Der Kopiervorgang ist fehlgeschlagen",
  "share.text": "Meine 30-sekündige Einführung",
  "share.failed": "Konnte nicht geteilt werden",
  "share.published": "Veröffentlicht",
  "share.draft": "Entwurf",
  "share.style": "Stil",
  "share.alt": "Share-Karte von {name}",
  "share.publishFirst": "Zum Teilen veröffentlichen",
  "share.action": "Teilen",
  "share.download": "Herunterladen",
  "share.openPublicPage": "Öffentliche Seite öffnen",
  "share.chooseStyle": "Wählen Sie den Kartenstil",
  "share.close": "Schließen",
  "share.cardStyle": "Kartenstil",
  "share.chooseOne": "Wählen Sie einen Stil",
  "share.chooseStyleAria": "Wählen Sie den Share-Card-Stil",
  "share.saving": "Wird gespeichert",
  "validation.body.placeholderDetail.legacyTemplate": "die alte Textvorlage",
  "validation.body.placeholderDetail.ellipsis": "der Platzhalter „...“.",
  "validation.body.placeholderDetail.sampleLink": "den Beispiellink „https://example.com“.",
  "validation.body.placeholderDetail.projectName": "der Platzhalter „项目名“.",
  "validation.body.placeholderDetail.instruction": "Vorlage für Anweisungstext",
  "analytics.gate.signInTitle": "Melde dich an, um die Analyse zu sehen",
  "analytics.gate.signInCopy": "Deine Besuchs- und Interaktionsdaten bleiben sicher im Dashboard.",
  "analytics.gate.signInAction": "Anmelden",
  "analytics.gate.proTitle": "Finde heraus, ob deine Vorstellung bis zum Ende gelesen wird.",
  "analytics.gate.proCopy": "Sieh aktive Lesezeit, Abschlussrate, Fortschrittsverteilung, Trends über 30, 90 und 365 Tage sowie Link-CTR.",
  "analytics.gate.proAction": "30s Pro ansehen",
  "analytics.gate.emptyTitle": "Nach der Veröffentlichung beginnen hier deine Daten.",
  "analytics.gate.emptyCopy": "Erstelle zuerst deine 30-Sekunden-Vorstellung. Nach der Veröffentlichung siehst du Besuchs- und Interaktionstrends.",
  "analytics.gate.emptyAction": "Jetzt erstellen",
  "analytics.gate.privacyNote": "Tägliche UTC-Aggregation · Anonyme Deduplizierung · Keine Speicherung der ursprünglichen IP-Adresse",
  "handleEdit.previous": "Geschützte frühere Adressen",
  "handleEdit.deadlines": "Weiterleitung bis {redirectDate}; Schutz bis {releaseDate}.",
  "handleEdit.usePrevious": "Diese Adresse verwenden",
  "handleEdit.reclaimAvailable": "Du kannst diese frühere Adresse zurückholen.",
  "publish.handleReclaimed": "Das Zurückholen zählt als Adressänderung. Für die aktuelle Adresse beginnen erneut 30 Tage Weiterleitung und 180 Tage Schutz."
}
